module.exports = __webpack_public_path__ + "img/paypal-old.088a8978.png";